export const apis = {
    //profile
    GET_TRANSACTION: 'api/getTransaction/',
    EDIT_PROFILE: 'api/userUpdate/',
};